import { MutableRefObject, Dispatch, SetStateAction } from 'react';

export default function infiniteScroll(
  renderPosts: object[],
  itemsEnd: MutableRefObject<any>,
  itemsToShow: number,
  setItemsToShow: Dispatch<SetStateAction<number>>,
) {
  const currentItemsEnd = itemsEnd.current;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.map((entry) => {
        if (entry.intersectionRatio > 0 && itemsToShow < renderPosts.length) {
          observer.unobserve(entry.target);
          setItemsToShow(itemsToShow + 3);
        }
      });
    },
    {
      rootMargin: '200px',
      threshold: 0.15,
    },
  );
  renderPosts.length && currentItemsEnd && observer.observe(currentItemsEnd);

  return () => {
    // Clean up the observer
    renderPosts.length && currentItemsEnd && observer.unobserve(currentItemsEnd);
  };
}
